module.exports = __webpack_public_path__ + "static/media/deities3.3146c741.jpeg";